export const hero = {
  "title": "Wymieniaj się z gospodarzami,",
  "titleHighlight": "w całej Europie",
  "subtitle": "Europejski klub wymiany zarezerwowany dla gospodarzy Airbnb z oceną 4,5+ i jedyną subskrypcją europejską.",
  "cta": "Rozpocznij wymianę",
  "learnMore": "Dowiedz się więcej",
  "stats": {
    "owners": "Aktywni właściciele",
    "countries": "Dostępne kraje",
    "exchanges": "Zrealizowane wymiany"
  },
  "slogans": {
    "slogan1": {
      "title": "Klub prywatny",
      "highlight": "gospodarze Airbnb 4,5+",
      "subtitle": "Dostęp zarezerwowany dla wysoko ocenianych gospodarzy, aby wymieniać się w zaufaniu."
    },
    "slogan2": {
      "title": "Oferta startowa 2026",
      "highlight": "-50% dla pierwszych 1000",
      "subtitle": "25EUR/rok zamiast 50EUR/rok, z dożywotnią gwarancją ceny."
    },
    "slogan3": {
      "title": "Gwarancja ceny do życia",
      "highlight": "1000 pierwszych członków",
      "subtitle": "Pierwszych 1000 zarejestrowanych zachowuje swoją stawkę na całe życie."
    },
    "slogan4": {
      "title": "Bez pośredników,",
      "highlight": "tylko relacje",
      "subtitle": "Zaufana społeczność, gdzie wymienia się pobyty, a nie sprzedaje noclegi."
    },
    "slogan5": {
      "title": "Dołącz do klubu",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "Klub wymiany stworzony dla aktywnych gospodarzy Airbnb w Europie."
    },
    "slogan6": {
      "title": "Niski sezon",
      "highlight": "zoptymalizowany",
      "subtitle": "Zamień swoje martwe okresy w okazje do podróżowania."
    },
    "slogan7": {
      "title": "Zrób przerwę,",
      "highlight": "uniknij wypalenia",
      "subtitle": "Odetchnij między dwoma okresami przyjmowania gości, wymieniając swój dom."
    },
    "slogan8": {
      "title": "Duch podróży,",
      "highlight": "prawdziwy",
      "subtitle": "Poznaj innych gospodarzy i odkrywaj nowe miejsca tanim kosztem."
    },
    "slogan9": {
      "title": "100% wyprodukowano we Francji",
      "highlight": "(Pikardia)",
      "subtitle": "Nie Dolina Krzemowa, ale Dolina Górnej Sommy. Rzemieślnicza, ludzka platforma dumna ze swoich korzeni."
    }
  }
};
